module.exports = __webpack_public_path__ + "static/media/ITA.cef0c449.png";